import type { I18nTranslate } from '@openx/types/translations.ts';

import { EN_LOCALE, JP_LOCALE, LANGUAGE_LOCAL_STORAGE_KEY, LANGUAGES } from './constants.ts';
import type { Locale } from './types.ts';

export const checkLocale = (locale: string, languages: string[] = LANGUAGES) => {
  if (!locale || !languages.includes(locale)) {
    return EN_LOCALE;
  }

  return locale;
};

export const getCurrentLocale = () =>
  window.localStorage.getItem(LANGUAGE_LOCAL_STORAGE_KEY) || navigator.language || navigator.languages[0];

export const getLocales = (t: I18nTranslate): Locale[] => [
  { id: EN_LOCALE, name: t('English / United States') },
  { id: JP_LOCALE, name: t('Japanese') },
];
